import PageRenderer from '../../components/PageRenderer/PageRenderer';

function Portfolio() {
  return <PageRenderer pageKey="portfolio" />;
}

export default Portfolio;
